import React, { useState } from "react";

import {
    faPenToSquare,
    faTrash,
    faEye,
    faToolbox
} from "@fortawesome/free-solid-svg-icons";

import Swal from 'sweetalert2'



const RRProcedimientos = ({procedimiento, i, FontAwesomeIcon, setProcToModify, setShowABM, eliminarProcedimiento, actualizarProcedimientoList, handleLookInfo, getProcedimientoByID}) => {

    const handleClickModify = async() => {
        if(procedimiento.owner != 'system'){
            let res = await getProcedimientoByID(procedimiento._id);
            if(res?.data?.procedimiento != undefined){
                setProcToModify(res.data.procedimiento);
                setShowABM(false);
            }
        }else{
            Swal.fire({
                title: "Este procedimiento es creado por el sistema y el mismo no permite editarlo",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }
    }

    const handleClickDelete = async () => {
        if(procedimiento.owner != 'system'){
            Swal.fire({
                title: `Está seguro que desea eliminar el procedimiento ${procedimiento.codProc}?`,
                showDenyButton: true,
                confirmButtonText: 'Sí, estoy seguro',
                confirmButtonColor: '#ff0000',
                denyButtonColor: '#3d4d87',
                denyButtonText: 'No',
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    eliminarProcedimiento(procedimiento)
                    .then(res => {
                        if(res.data?.deleted !== undefined && res.data.deleted == true ){
                            Swal.fire({
                                title: `${res.data.message}`,
                                icon: 'success',
                                showConfirmButton: true,    
                                allowEnterKey: true
                            });
                            setShowABM(true);
                            setProcToModify({});
                            actualizarProcedimientoList();
                        }else if(res.data?.deleted !== undefined && res.data.deleted == false){
                            Swal.fire({
                                title: `${res.data.message}`,
                                icon: 'error',
                                showConfirmButton: true,    
                                allowEnterKey: true
                            });
                            setShowABM(true);
                            setProcToModify({});
                        }
                    })
                } 
            })
        }else{
            Swal.fire({
                title: "Este procedimiento es creado por el sistema y el mismo no permite eliminarlo",
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
            return;
        }
    }

    return <div className="procedimientoRow">
        <div className="infoContainer">
            <FontAwesomeIcon icon={faToolbox} className="rrIcon" id="primaryIcon"/>
            <div className="infoDiv">
                <h6>Código Procedimiento:</h6>
                <label id="codProcLabel">{procedimiento.codProc}</label>
            </div>
            <div className="infoDiv">
                <h6>Nombre Procedimiento:</h6>
                <label>{procedimiento.name}</label>
            </div>
            <div className="infoDiv">
                <h6>Tipo Activo:</h6>
                <label>{procedimiento.tipAct}</label>
            </div>
            <div className="infoDiv">
                <h6>Unidad de Medida:</h6>
                <label>{procedimiento.uniMed.label}</label>
            </div>
        </div>
        <div className="funcionesDiv">
            <FontAwesomeIcon icon={faEye} className="rrIcon" onClick={()=> handleLookInfo(procedimiento)}/>
            <FontAwesomeIcon icon={faPenToSquare} onClick={() => handleClickModify()} className="rrIcon"/>
            <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={() => handleClickDelete()}/>
        </div>  
    </div>

}

export default RRProcedimientos;